"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackPageChanged = exports.trackEvent = exports.identifyUser = exports.default = void 0;
var _SegmentConnector = _interopRequireDefault(require("./connectors/SegmentConnector"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var identifyUser = function identifyUser(user, additionalInformation) {
  return _SegmentConnector.default.identifyUser(user, additionalInformation);
};
exports.identifyUser = identifyUser;
var trackPageChanged = function trackPageChanged() {
  return _SegmentConnector.default.trackPageChanged();
};
exports.trackPageChanged = trackPageChanged;
var trackEvent = function trackEvent(eventName, user, properties) {
  return _SegmentConnector.default.trackEvent(eventName, user, properties);
};
exports.trackEvent = trackEvent;
var _default = {
  identifyUser: identifyUser,
  trackPageChanged: trackPageChanged,
  trackEvent: trackEvent
};
exports.default = _default;
//# sourceMappingURL=Segment.js.map